import {Controller} from "@hotwired/stimulus"
import signals from "signals"
import Headroom from "headroom.js"

class HeadroomController extends Controller {
  static values = {
    offset: {type: Number, default: 0}
  }

  connect() {
    const headroom = new Headroom(this.element, {
      classes: {
        initial: "headroom",
        pinned: "headroom-pinned",
        unpinned: "headroom-unpinned",
        top: "headroom-top",
        notTop: "headroom-not-top"
      },
      offset: this.offsetValue
    })
    headroom.init()
    // the topbar would be visible if a page menu entry was clicked where the
    // associated section is further up, which we want to prevent
    signals.on("kenhub.viewport_changed", () =>
      setTimeout(() => this.unpin(), 10)
    )
    // the same applies when someone filters the content
    signals.on("kenhub.filter_manager_filtered", () =>
      setTimeout(() => this.unpin(), 10)
    )
  }

  unpin() {
    if (this.element.classList.contains("headroom-top")) return

    this.element.classList.remove("headroom-pinned")
    this.element.classList.add("headroom-unpinned")
  }
}

export default HeadroomController
